import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectSpraySubmissionHasError } from 'services/spraySubmission/selectors';
import { AppState } from 'services/types';
import RoleButton from 'components/RoleButton';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import { SPRAY_SUBMISSION_CONFIRMATION_MODAL } from '../SpraySubmissionConfirmationModal';

interface ConnectedProps {
    submissionCanBeResubmitted: ReturnType<typeof selectSpraySubmissionHasError>;
}

type Props = ConnectedProps;

export class SpraySubmissionSubmitButtonComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { submissionCanBeResubmitted } = this.props;

        if (submissionCanBeResubmitted) {
            return (
                <RoleButton
                    requiredRoles={[ADMIN, MANAGER]}
                    buttonProps={{
                        secondary: true
                    }}
                    params={{
                        [SPRAY_SUBMISSION_CONFIRMATION_MODAL]: true
                    }}
                >
                    Re-submit
                </RoleButton>
            )
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    submissionCanBeResubmitted: selectSpraySubmissionHasError
});

export default connect(mapStateToProps)(SpraySubmissionSubmitButtonComponent);
